module.exports = __webpack_public_path__ + "img/list1.72be4ffb.png";